const keys = {
  updateApp: ['update_app'],
}

export default keys
